<template>
  <div class="lottery-container">
    <div class='window' :style="{width: px2rem(windowWidth)}">
    <!-- 滚动轨道 -->
    <div
      class="track"
      ref="track"
      :style="{ transform: `translateX(${px2rem(offset)})` }"
    >
      <!-- 三倍数据实现无缝滚动 -->
      <div
        v-for="(item, index) in extendedList"
        :key="index"
        class="lottery-item"
        :class="{ 'highlight': shouldHighlight(index) }"
        :style="{width: px2rem(itemWidth), margin: `0 ${px2rem(itemMargin)}`}"
      >
        <slot name="item" :item="item.origin" :index="index">
          {{ item.origin.prizeName }}
        </slot>
      </div>
    </div>
    </div>

    <!-- 控制按钮 -->
    <button
      class="control-btn"
      @click="handleControl"
      :disabled="disabledBtn"
    >
      {{ buttonText }}
    </button>

    <!--  抽奖过程  -->
    <audio ref="audiot" @ended="onEnded" controls class="displyNone">
      <source src="../assets/mp3/t.mp3" type="audio/mp3">
    </audio>
    <!--  抽中  -->
    <audio ref="audios" controls class="displyNone">
      <source src="../assets/mp3/s.mp3" type="audio/mp3">
    </audio>
    <!--  失败  -->
    <audio ref="audiof" controls class="displyNone">
      <source src="../assets/mp3/f.mp3" type="audio/mp3">
    </audio>
    <!-- <div class="accelerating">
      <img src="../assets/img/ts.png" class="ts"/>
      <img src="../assets/img/dialog.png" class="bg"/>
      <img src="../assets/img/fr/submit.png" class="submit"/>
    </div> -->
  </div>
</template>

<script>
import { px2rem } from '../utils/px2Rem'
// 物理运动模拟器
class PhysicsEngine {
  constructor (config) {
    this.config = {
      maxSpeed: 1000, // 像素/秒
      acceleration: 500, // 像素/秒²
      evenSpeed: 100,
      ...config
    }
    this.velocity = 0
    this.minVelocity = 0.2 // 最小停止速度
    this.lastTime = null
  }

  // 更新速度（返回位移增量）
  update (accelerating, deltaTime) {
    const dt = deltaTime / 1000 // 转换为秒
    switch (accelerating) {
      case 'idle':
        this.velocity = this.config.evenSpeed
        break
      default:
        this.velocity += this.config.acceleration * dt
        this.velocity = Math.min(this.velocity, this.config.maxSpeed)
        break
    }
    return this.velocity * dt
  }
}

export default {
  props: {
    items: { type: Array, required: true },
    itemWidth: { type: Number, default: 150 },
    targetIndex: { type: [Number, String], default: -1 },
    isUsed: { type: Boolean, default: false },
    disabledBtn: { type: Boolean, default: false }
  },
  data () {
    return {
      offset: 0, // 当前偏移量
      status: 'idle', // 状态：idle | accelerating | decelerating
      targetPosition: null,
      highlightIndex: -1, // 当前高亮的索引
      physics: null, // 物理引擎实例
      startTimestamp: 0, // 动画开始时间
      lastFrameTime: 0, // 上一帧时间
      itemMargin: 60
    }
  },
  computed: {
    // 三倍扩展数据（实现无缝）
    extendedList () {
      return [...this.items, ...this.items, ...this.items]
        .map((origin, index) => ({ origin, group: Math.floor(index / this.items.length) }))
    },

    // 实际奖品数量
    actualCount () {
      return this.items.length
    },
    // 一个奖项的总宽度
    tallItemWidth () {
      return this.itemMargin * 2 + this.itemWidth
    },
    // windowWidth
    windowWidth () {
      return (this.itemWidth + this.itemMargin * 2) * 3
    },
    // 按钮文字
    buttonText () {
      return {
        idle: 'Démarrer le tirage',
        accelerating: 'Résultats du tirage',
        decelerating: 'Démarrer le tirage'
      }[this.status]
    }
  },
  created () {
    this.physics = new PhysicsEngine()
  },
  mounted () {
    requestAnimationFrame(this.addSpeedAnimate)
    this.offset = -this.tallItemWidth
  },
  methods: {
    // 行内样式px转rems
    px2rem,
    // 匀速加速画循环
    addSpeedAnimate (timestamp) {
      if (!this.startTimestamp) this.startTimestamp = timestamp
      const deltaTime = timestamp - (this.lastFrameTime || timestamp)

      // 计算位移增量
      const delta = this.physics.update(
        this.status,
        deltaTime
      )

      // 更新位置
      this.offset -= delta

      const centerPos = Math.abs(this.offset) + this.windowWidth / 2
      const index = Math.floor(centerPos / this.tallItemWidth) % this.actualCount
      this.highlightIndex = Math.min(Math.max(index, 0), this.actualCount - 1)

      this.handleBoundary()

      // 智能停止条件
      if (this.shouldStop()) {
        this.finalizePosition()
        return
      }
      this.lastFrameTime = timestamp
      requestAnimationFrame(this.addSpeedAnimate)
    },

    // 处理边界（无缝核心）
    handleBoundary () {
      const threshold = this.tallItemWidth * this.actualCount
      if (Math.abs(this.offset) >= threshold) {
        this.offset += threshold
      }
    },

    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },

    easeOutLinear (currentTime, duration, startValue, minValue) {
      const t = Math.min(Math.max(currentTime, 0), duration)
      const progress = t / duration
      const currentValue = startValue * (1 - progress) + minValue * progress
      return currentValue
    },

    // 开始抽奖
    async start () {
      if (this.isUsed) {
        this.$emit('start')
        return
      }
      this.status = 'accelerating'
      this.targetIndex = -1
      this.startTimestamp = 0
      this.lastFrameTime = 0
      this.physics.velocity = 0
      requestAnimationFrame(this.addSpeedAnimate)
      // 生成6-10秒的随机整数
      const randomSeconds = this.getRandomInt(4, 6)

      setTimeout(() => {
        console.log('randomSeconds', randomSeconds)

        this.stop()
      }, 1000 * randomSeconds)
    },

    // 新增：停止条件判断
    shouldStop () {
      return this.highlightIndex === this.targetIndex
    },

    // 计算中奖项最终位移
    calculateTargetPosition () {
      let targetOffset = -(this.targetIndex - 1) * this.tallItemWidth
      if (this.targetIndex === 0) {
        targetOffset = -(this.actualCount - 1) * this.tallItemWidth
      }
      return targetOffset
    },

    // 停止抽奖
    async stop () {
      // 获取结果（示例随机，可替换为API）
      await new Promise((resolve) => {
        this.$emit('stop', '数据', resolve)
      })
      console.log('this.targetIndex', this.targetIndex)
      if (this.targetIndex === 'THANK') {
        this.restart()
      } else {
        this.status = 'decelerating'
        // 计算目标位置
        this.targetPosition = this.calculateTargetPosition()
      }
    },

    // 最终定位
    finalizePosition () {
      this.offset = this.targetPosition
      this.physics.velocity = 0
      setTimeout(() => {
        this.$emit('finish')
      }, 500)
    },
    // 判断高亮
    shouldHighlight (index) {
      return (
        this.highlightIndex !== -1 &&
        index % this.actualCount === this.highlightIndex
      )
    },
    restart () {
      this.status = 'idle'
      this.targetIndex = -1
      this.startTimestamp = 0
      this.lastFrameTime = 0
      requestAnimationFrame(this.addSpeedAnimate)
    },

    // 控制按钮点击
    handleControl () {
      console.log('this.status', this.status)
      let finalFn
      switch (this.status) {
        case 'idle':
          finalFn = this.start()
          break
        case 'accelerating':
          // finalFn = this.stop()
          break
        case 'decelerating':
          finalFn = this.start()
      }
      return finalFn
    },

    // 获取结果（示例方法）
    async getResultIndex () {
      return new Promise(resolve => {
        setTimeout(() => resolve(Math.floor(Math.random() * this.actualCount)), 300)
      })
    },

    onEnded () {
      this.$refs.audiot.currentTime = 0
      this.$refs.audiot.play()
    }
  }
}
</script>

<style scoped>
.lottery-container {
  position: absolute;
  overflow: hidden;
  top: 20%;
  width: 100%;
  height: 420px;
}
.window {
  display: flex;
  align-items:  center;
  position: relative;
  transform: translateX(-50%);
  left: 50%;
  height: auto;
  overflow: hidden;
}
 /* .window::after {
    position: absolute;
    display: block;
    content: '';
    width: 0.02667rem;
    height: 8rem;
    background: yellow;
    left: 50%;
    top: 0;
  } */

.track {
  display: flex;
  will-change: transform; /* 启用GPU加速 */
  transition-duration: 0.3;
}

.lottery-item {
  flex-shrink: 0;
  height: 420px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s cubic-bezier(0.18, 0.89, 0.32, 1.28);
}

.lottery-item.highlight {
  border-radius: 12px;
  transform: scale(1.5);
}

.control-btn {
  width: 88%;
  padding: 32px;
  box-sizing: border-box;
  position: fixed;
  top: 83%;
  left: 50%;
  transform: translateX(-50%);
  margin: 0;
  background: #ff4757;
  color: white;
  border: none;
  font-weight: 600;
  border-radius: 30px;
  font-size: 24px;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(255, 71, 87, 0.4);
  z-index: 100;
}

.control-btn:disabled {
  background: #a4b0be;
  cursor: not-allowed;
  box-shadow: none;
}

  .displyNone {
    display: none;
  }
  .accelerating {
    position: fixed;
    width: 100%;
    height: auto;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .accelerating .bg {
    width: 100%;
    height: auto;
  }
  .accelerating .ts {
    position: absolute;
    top: 0;
    width: 50%;
    height: auto;
    margin: 0 auto;
    margin-top: 3%;
  }
  .accelerating .submit {
    position: absolute;
    width: 80%;
    height: auto;
  }

</style>
